import { CONTENT_TYPES } from 'components/ContentReporting/content-types';
import {
  isAlbumsReportingEnabledForCountry,
  isPodcastReportingEnabledForCountry,
} from 'components/ContentReporting/market-helper';
import { FEATURE_FLAG } from 'components/ContentReporting/feature-flags';

export const getAvailableUriTypesPerCountry = ({
  isEmployee,
  userCountryIsoCode,
  isFeatureFlagEnabled,
}: {
  isEmployee: boolean;
  userCountryIsoCode: string;
  // NOTE: Do not remove isFeatureFlagEnabled even if empty/unused. This simplifies adding feature flags in the future.
  isFeatureFlagEnabled?: (featureFlag: FEATURE_FLAG) => boolean;
}): CONTENT_TYPES[] => {
  return [
    CONTENT_TYPES.USER,
    CONTENT_TYPES.PLAYLIST,
    CONTENT_TYPES.PLAYLIST_OLD,
    CONTENT_TYPES.ARTIST,
    CONTENT_TYPES.TRACK,
    CONTENT_TYPES.ARTIST_VIDEO,
    CONTENT_TYPES.POLL,
    CONTENT_TYPES.MERCH,
    CONTENT_TYPES.COMMENT,
    CONTENT_TYPES.EXPRESSION,
    CONTENT_TYPES.SUPPLEMENTARY_MATERIAL,
    ...(isEmployee || isPodcastReportingEnabledForCountry(userCountryIsoCode)
      ? [CONTENT_TYPES.SHOW, CONTENT_TYPES.EPISODE]
      : []),
    ...(isEmployee || isAlbumsReportingEnabledForCountry(userCountryIsoCode) ? [CONTENT_TYPES.ALBUM] : []),
    ...(isFeatureFlagEnabled?.(FEATURE_FLAG.CHAT_MESSAGE) ? [CONTENT_TYPES.CHAT_MESSAGE] : []),
    ...(isFeatureFlagEnabled?.(FEATURE_FLAG.AUTHOR) ? [CONTENT_TYPES.AUTHOR] : []),
  ];
};
